import { globalConstants, candidateConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  allData: [],
  formData: {},
};
//Manipulating the state of admin portal based on actions and returning the state
export const candidateReducer = (state = initialState, action) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATES + SUCCESS:
      return { ...state, data: action.data };
    case candidateConstants.GET_CANDIDATES_LIST + SUCCESS:
      return { ...state, allData: action.data };
    case candidateConstants.GET_CANDIDATE_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    default:
      return state;
  }
};
